import { FIELDS_TO_TRANSFORM } from "services/sosInventoryService/salesReceipt/schema";
import { salesTransactionBeforeSave } from "services/sosInventoryService/salesTransaction/beforeSave";
import { normalizeDateFields } from "services/utility/beforeSave";

import { OBJECT_TYPES } from "appConstants";

export function beforeSave(record) {
  let newRecord = salesTransactionBeforeSave(
    OBJECT_TYPES.SALES_RECEIPT.fullString,
    record
  );
  newRecord = normalizeDateFields(newRecord, FIELDS_TO_TRANSFORM.DATE_FIELDS);

  // Remove UI-only field; not used by the API
  delete newRecord.persistedPaymentMethodIsSosPay;

  return newRecord;
}
